import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 検索条件表示フィールド
 *【内容:itemValue:string[]】
 *【ラベル内容:itemName:string】
 *【表示条件:visible:boolean】
 *【選択候補:candidates:{label:string,value:string}[]】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-condition-field',
  templateUrl: './search-condition-field.html',
  styles: [`
    
  `]
})
export class SearchConditionField extends BaseWidget {
  /**
   * 内容
   */
  @Input() itemValue:string[]

  /**
   * ラベル内容
   */
  @Input() itemName:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string}[]

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get _itemValue():string[] {
    let target: string[] = [];
    let conditionList: string[] = [];
    if (!Array.isArray(this.itemValue)) {
      conditionList.push(this.itemValue);
    } else {
      conditionList = this.itemValue;
    }
    this.candidates = this.candidates ? this.candidates : [];
    if (this.candidates.length !== 0) {
      this.candidates.forEach((each) => {
        let exist: boolean = false;
        exist = conditionList && conditionList.some(c => c === each.value)
        if (exist) {
          target.push(each.label);
        }
      });
    } else {
      target = conditionList;
    }
    return target;
  }
}


// WEBPACK FOOTER //
// ./src/widgets/search_condtion/search-condition-field/search-condition-field.component.ts